import type { Service } from '../../../redux/types.ts';
import _snakeCase from 'lodash.snakecase';
import cn from 'classnames';
import styles from './searchBar.module.scss';
import DefaultServiceIcon from '../../../../public/default-icon.77de1e40.svg';
import { highlightedText } from './highlightedTextUtils';

const { disabledService, optionIcon, optionText, optionTitle, optionDescription, userService, accountService } = styles;

const ServiceTile = ({
  service,
  onClick,
  query,
}: {
  service: Service;
  onClick: (s: Service) => void;
  query?: string;
}) => {
  return (
    <div
      data-testid={`search-option-${service.name ?? _snakeCase(service.title)}`}
      className={cn(styles.option, {
        [disabledService]: !service.enabled,
        [userService]: !service.requireAccount,
        [accountService]: service.requireAccount,
      })}
      onClick={() => onClick(service)}
      key={`${_snakeCase(service.title)}-${service.path}`}
    >
      <img className={optionIcon} src={service.iconUrl ?? DefaultServiceIcon} alt="icon" />
      <div className={optionText}>
        <span className={optionTitle}>{highlightedText(service.title, query)}</span>
        <span className={optionDescription}>{highlightedText(service.description, query)}</span>
      </div>
    </div>
  );
};

export default ServiceTile;
